import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';

class RequestApi {
  /**
   * 增加车辆收藏
   * @param {string[]} vehicleNameList
   * @return {Promise<any>}
   */
  async addAttention(vehicleNameList: string[]): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/monitor/web/attention/add_vehicle',
      method: Method.POST,
      body: {
        vehicleNameList: vehicleNameList,
      },
    };
    return request(requestParams);
  }

  /**
   * 取消车辆收藏
   * @param {string[]} vehicleNameList
   * @return {Promise<any>}
   */
  async removeAttention(vehicleNameList: string[]): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/monitor/web/attention/cancel_vehicle',
      method: Method.POST,
      body: {
        vehicleNameList: vehicleNameList,
      },
    };
    return request(requestParams);
  }

  /**
   * 一键清空收藏车辆
   * @return {Promise<any>}
   */
  async removeAllAttention(): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/monitor/web/attention/cancel_all',
      method: Method.POST,
    };
    return request(requestParams);
  }
}

export default RequestApi;
